import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import {
  ArrowPathRoundedSquareIcon,
  CubeIcon,
  CurrencyRupeeIcon,
  ListBulletIcon,
  QueueListIcon,
  UserGroupIcon,
} from "@heroicons/react/24/solid";
import { ChartBarIcon, XCircleIcon } from "@heroicons/react/20/solid";
import { toast } from "react-toastify";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Line,
  ComposedChart,
  Scatter,
} from "recharts";
import { motion } from "framer-motion";
import "./../../../App.css";
import { Select } from "@material-tailwind/react";
import {
  ArrowDown01,
  ArrowDown01Icon,
  ArrowRightCircle,
  ArrowRightIcon,
  ArrowUp01Icon,
  UserIcon,
  Users,
} from "lucide-react";
import "../../../../src/App.css";

function LeadDashboardPage() {
  let currentLoginIdName = "";
  currentLoginIdName = localStorage.getItem("user_name");

  const currentLoginIdForAdmin = parseInt(localStorage.getItem("role_id"), 10); //current login oda user_id 1 ah irundha ? ella datas um show panrom
  const currentLoginIdForEmployee = JSON.parse(localStorage.getItem("user"))
    ?.employee?.id; // current login oda user la iruka employee oda id namba task la iruka task_member la iruka id oda match aachu apdina and employee oda tasks matum  list out panrom

  console.log(currentLoginIdForEmployee, "hello");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [leadDatas, setLeadDatas] = useState([]);
  const [customerDatas, setCustomerDatas] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [activeTabsForLead, setActiveTabsForLeads] = useState("completed");
  const [activeTabsForQuotation, setActiveTabsForQuotation] =
    useState("approved");
  const [activeTabsForTask, setActiveTabsForTask] = useState("completed");
  const [activeTabsForEmployees, setActiveTabsForEmployees] =
    useState("totalEmployees");

  const [allDatasCount, setAllDatasCount] = useState([]);
  const [allLeadDatas, setAllLeadDatas] = useState([]);
  const [allQuotationDatas, setAllQuotationDatas] = useState([]);
  const [allTaskDatas, setAllTaskDatas] = useState([]);
  const [allEmployeeDatas, setAllEmployeeDatas] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [leadFilter, setLeadFilter] = useState({
    select_period: "",
    start_date: "",
    end_date: "",
  });
  const [customerFilter, setCustomerFilter] = useState({
    select_period: "",
    start_date: "",
    end_date: "",
  });
  const [leadChartData, setLeadChartData] = useState([]);
  const [customerChartData, setCustomerChartData] = useState([]);
  const [filteredTaskForDashboard, setFilteredTaskForDashboard] = useState([]);

  const navigate = useNavigate();

  const fetchDashboard = async () => {
    const token = localStorage.getItem("token");

    try {
      const responseForDashboard = await axios.get(
        "public/api/admin/dashboard",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(responseForDashboard?.data, "Dahsboard");

      setAllDatasCount(responseForDashboard?.data);

      const responseForDashboardLead = await axios.get(
        "public/api/admin/dashboard/leaddetails",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(responseForDashboardLead.data, "lead data");

      setAllLeadDatas(responseForDashboardLead?.data);

      const responseForDashboardQuotation = await axios.get(
        "public/api/admin/dashboard/quotationdetails",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setAllQuotationDatas(responseForDashboardQuotation?.data);

      const responseForDashboardTask = await axios.get(
        "public/api/admin/dashboard/taskdetails",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setAllTaskDatas(responseForDashboardTask?.data);

      const filteredTasks1 =
        currentLoginIdForAdmin === 1
          ? [
              ...(allTaskDatas?.data?.pending || []),
              ...(allTaskDatas?.data?.completed || []),
              ...(allTaskDatas?.data?.inprogress || []),
              ...(allTaskDatas?.data?.notyetstarted || []),
            ]
          : [
              ...(allTaskDatas?.data?.pending || []).filter((task) =>
                task.task_member.some(
                  (member) =>
                    parseInt(member.id, 10) ===
                    parseInt(currentLoginIdForEmployee)
                )
              ),
              ...(allTaskDatas?.data?.completed || []).filter((task) =>
                task.task_member.some(
                  (member) =>
                    parseInt(member.id, 10) ===
                    parseInt(currentLoginIdForEmployee)
                )
              ),
              ...(allTaskDatas?.data?.inprogress || []).filter((task) =>
                task.task_member.some(
                  (member) =>
                    parseInt(member.id, 10) ===
                    parseInt(currentLoginIdForEmployee)
                )
              ),
              ...(allTaskDatas?.data?.notyetstarted || []).filter((task) =>
                task.task_member.some(
                  (member) =>
                    parseInt(member.id, 10) ===
                    parseInt(currentLoginIdForEmployee)
                )
              ),
            ];
      setFilteredTaskForDashboard(filteredTasks1);

      const responseForDashboardEmployee = await axios.get(
        "public/api/admin/dashboard/employeedetails",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(
        responseForDashboardEmployee?.data,
        "responseForDashboardEmployee"
      );

      setAllEmployeeDatas(responseForDashboardEmployee?.data);

      const responseForLeads = await axios.get("public/api/admin/lead", {
        headers: { Authorization: `Bearer ${token}` },
      });

      setLeadDatas(responseForLeads?.data.lead);

      const responseForCustomer = await axios.get("public/api/admin/dashboard/customerdetails", {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(responseForCustomer?.data, "customer details");  
      
      setCustomerDatas(responseForCustomer?.data.customers);

      const now = new Date();

      // Ensure consistent date parsing by only taking the date portion
      const thisMonthTasks = tasks.filter((item) => {
        try {
          const itemDate = new Date(item?.created_at?.split("T")[0]);
          if (isNaN(itemDate.getTime())) {
            return false;
          }

          return (
            itemDate.getMonth() === now.getMonth() &&
            itemDate.getFullYear() === now.getFullYear()
          );
        } catch (error) {
          console.error("Error parsing date:", item.created_at, error);
          return false;
        }
      });

      setFilteredTasks(thisMonthTasks);
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

  useEffect(() => {
    const formattedData = leadDatas?.map((lead) => ({
      name: lead?.name,
      lead_value: Number(lead?.lead_value),
    }));
    setLeadChartData(formattedData);
  }, [leadDatas]);

  useEffect(() => {
    if (customerDatas && customerDatas.length > 0) {
      // Grouping data by month
      const groupedData = Object.values(
        customerDatas.reduce((acc, item) => {
          const month = new Date(item.created_at).toLocaleString("default", {
            month: "short",
            year: "numeric",
          });

          if (!acc[month]) {
            acc[month] = { name: month, Lead: 0, Direct: 0 };
          }

          if (item.status === "Lead") {
            acc[month].Lead += 1;
          } else if (item.status === "Direct") {
            acc[month].Direct += 1;
          }

          return acc;
        }, {})
      );

      setCustomerChartData(groupedData);
    }
  }, [customerDatas]);

  const tryAgain = () => {
    fetchDashboard();
  };

  const Notification = ({ message, onClose }) => {
    useEffect(() => {
      const timer = setTimeout(() => {
        onClose();
      }, 1000);

      return () => clearTimeout(timer);
    }, [onClose]);

    return (
      <div className="fixed top-24 right-14 w-62 p-4 bg-purple-600 text-white rounded-lg shadow-md">
        <p>{message}</p>
      </div>
    );
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 border border-gray-200 shadow-lg rounded-lg text-sm">
          <p className="font-bold text-gray-700">
            {payload[0].payload.lead_name}
          </p>
          <p className="text-indigo-600 font-medium">
            Value: {payload[0].value}
          </p>
        </div>
      );
    }
    return null;
  };

  const handleViewLead = (id_crypt) => {
    navigate("/crm/lead", { state: { id_crypt, showForm: true } });
  };
  const handleViewQuotation = (id_crypt) => {
    navigate("/crm/quotation", { state: { id_crypt, showForm: true } });
  };
  const handleViewTask = (id_crypt) => {
    navigate("/crm/all_leads_task", { state: { id_crypt, showForm: true } });
  };
  const handleViewEmployee = (id_crypt) => {
    navigate("/crm/lead_employees", { state: { id_crypt, showForm: true } });
  };
  const handleChangeForLeadFilter = (e) => {
    const { name, value } = e.target;

    setLeadFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitForLeadFilter = async () => {
    try {
      const response = await axios.post(
        "public/api/admin/dashboard/leadfilter",
        leadFilter,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      console.log(response.data, "response.data.leads");

      // setLeadChartData(response.data.leads);
      setAllLeadDatas(response.data);
    } catch (error) {}
  };

  // Handle Reset
  const handleResetForLeadFilter = async () => {
    setLeadFilter({
      select_period: "",
      start_date: "",
      end_date: "",
    });
    await fetchDashboard();
  };

  const handleChangeForCustomerFilter = (e) => {
    const { name, value } = e.target;

    setCustomerFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitForCustomerFilter = async () => {
    try {
      const response = await axios.post(
        "public/api/admin/dashboard/customerfilter",
        customerFilter,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      // Group data by month and count Lead & Direct customers
      const groupedData = Object.values(
        response.data.customers.reduce((acc, customer) => {
          const month = new Date(customer.created_at).toLocaleString(
            "default",
            {
              month: "short",
              year: "numeric",
            }
          );

          if (!acc[month]) {
            acc[month] = { name: month, Lead: 0, Direct: 0 };
          }

          if (customer.status === "Lead") {
            acc[month].Lead += 1;
          } else if (customer.status === "Direct") {
            acc[month].Direct += 1;
          }

          return acc;
        }, {})
      );

      // Update state with formatted chart data
      setCustomerChartData(groupedData);
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };

  // Handle Reset
  const handleResetForCustomerFilter = async () => {
    setCustomerFilter({
      select_period: "",
      start_date: "",
      end_date: "",
    });
    await fetchDashboard();
  };

  return (
    <div className="px-6 flex-1 bg-gradient-to-b from-gray-50 to-gray-100 rounded-2xl p-5 overflow-x-hidden">
      {loading ? (
        <div class="h-screen bg-white">
          <div class="flex justify-center items-center h-full">
            <img
              class="h-16 w-16"
              src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
              alt="loader"
            />
          </div>
        </div>
      ) : error ? (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-300 bg-opacity-50 z-50">
          <div className="shadow-lg p-4 px-12 bg-white rounded-md flex flex-col items-center">
            <XCircleIcon className="h-12 w-12 text-red-600 opacity-75 mb-2" />
            <div className="mb-2 text-center text-gray-800 font-medium">
              {error}
            </div>
            <button
              onClick={tryAgain}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 w-full rounded"
            >
              Retry
            </button>
          </div>
        </div>
      ) : (
        <main className="">
          <div className="py-6 grid grid-cols-1 lg:grid-cols-2 gap-4">
            <div className="grid grid-cols-1 lg:grid-cols-1 gap-4">
              <div className="text-md md:text-md col-span-1 lg:col-span-2 font-semibold text-gray-900 mb-2 flex items-center space-x-4">
                <span>
                  <CubeIcon className="h-6 w-6 text-blue-600" />
                </span>
                <span className="flex space-x-2">
                  <h2 className="uppercase">Dashboard</h2>{" "}
                  <span className="hidden sm:block uppercase">Overview</span>
                </span>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-1 gap-4">
              <div className="text-md md:text-md flex sm:justify-end col-span-1 lg:col-span-2 font-semibold text-gray-900 mb-2 flex items-center space-x-4">
                <h2 className="">
                  Welcome{" "}
                  <span className="text-blue-600 uppercase font-bold">
                    {currentLoginIdName?.replace(/"/g, "")}
                  </span>
                </h2>
              </div>
            </div>
          </div>

          <div class="mx-auto grid grid-cols-1 text-center gap-px bg-gray-900/5 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 mt-0 sm:mt-5">
            <div
              class="flex flex-wrap text-center justify-center  gap-x-4 gap-y-2 bg-white px-4 py-10 hover:bg-green-50 hover:shadow-lg hover:scale-105 transition-all duration-300 
             hover:cursor-pointer"
              onClick={() => navigate("/crm/customer")}
            >
              <div class="text-sm/6 font-medium text-gray-500 text-center">
                Customers
              </div>
              <div class="w-full flex justify-center items-center gap-x-2 text-3xl/10 font-medium tracking-tight text-gray-900">
                <span class="inline-flex shrink-0 items-center rounded-full bg-green-50 px-1.5 py-1.5 text-xs font-medium text-green-700 ring-1 ring-green-600/20 ring-inset">
                  <UserGroupIcon className="h-6 w-6 text-green-600" />
                </span>

                {allDatasCount?.customerTotalCount}
              </div>
            </div>
            <div
              class="flex flex-wrap text-center justify-center  gap-x-4 gap-y-2 bg-white px-4 py-10 hover:bg-red-50 hover:shadow-lg hover:scale-105 transition-all duration-300 
             hover:cursor-pointer"
              onClick={() => navigate("/crm/customer")}
            >
              <div class="text-sm/6 font-medium text-gray-500">
                Converted to Customers
              </div>
              <div class="w-full flex justify-center items-center gap-x-2 text-3xl/10 font-medium tracking-tight text-gray-900">
                <span class="inline-flex shrink-0 items-center rounded-full bg-red-300 px-1.5 py-1.5 text-xs font-medium text-red-700 ring-1 ring-red-600/20 ring-inset">
                  <ArrowPathRoundedSquareIcon className="h-6 w-6 text-red-600" />
                </span>
                {allDatasCount?.convertedcustomer}
              </div>
            </div>
            <div
              class="flex flex-wrap text-center justify-center  gap-x-4 gap-y-2 bg-white px-4 py-10  hover:bg-blue-50 hover:shadow-lg hover:scale-105 transition-all duration-300 
             hover:cursor-pointer"
              onClick={() => navigate("/crm/lead_employees")}
            >
              <div class="text-sm/6 font-medium text-gray-500">Employees</div>
              <div class="w-full flex justify-center items-center gap-x-2 text-3xl/10 font-medium tracking-tight text-gray-900">
                <span class="inline-flex shrink-0 items-center rounded-full bg-blue-300 px-1.5 py-1.5 text-xs font-medium text-blue-700 ring-1 ring-blue-600/20 ring-inset">
                  <Users className="h-6 w-6 text-blue-600" />
                </span>
                {allDatasCount?.employeeTotalCount}
              </div>
            </div>
            <div
              class="flex flex-wrap text-center justify-center  gap-x-4 gap-y-2 bg-white px-4 py-10  hover:bg-yellow-50 hover:shadow-lg hover:scale-105 transition-all duration-300 
             hover:cursor-pointer"
              onClick={() => navigate("/crm/lead")}
            >
              <div class="text-sm/6 font-medium text-gray-500">Leads</div>
              <div class="w-full flex justify-center items-center gap-x-2 text-3xl/10 font-medium tracking-tight text-gray-900">
                <span class="inline-flex shrink-0 items-center rounded-full bg-yellow-300 px-1.5 py-1.5 text-xs font-medium text-yellow-700 ring-1 ring-yellow-600/20 ring-inset">
                  <ChartBarIcon className="h-6 w-6 text-yellow-600" />
                </span>
                {allDatasCount?.leadTotalCount}
              </div>
            </div>
            <div
              class="flex flex-wrap text-center justify-center  gap-x-4 gap-y-2 bg-white px-4 py-10 hover:bg-indigo-50 hover:shadow-lg hover:scale-105 transition-all duration-300 
             hover:cursor-pointer"
              onClick={() => navigate("/crm/quotation")}
            >
              <div class="text-sm/6 font-medium text-gray-500">Quotations</div>
              <div class="w-full flex justify-center items-center gap-x-2 text-3xl/10 font-medium tracking-tight text-gray-900">
                <span class="inline-flex shrink-0 items-center rounded-full bg-indigo-300 px-1.5 py-1.5 text-xs font-medium text-indigo-700 ring-1 ring-indigo-600/20 ring-inset">
                  <ListBulletIcon className="h-6 w-6 text-indigo-800" />
                </span>
                {allDatasCount?.quotationTotalCount}
              </div>
            </div>
            <div
              class="flex flex-wrap text-center justify-center  gap-x-4 gap-y-2 bg-white px-4 py-10 hover:bg-purple-50 hover:shadow-lg hover:scale-105 transition-all duration-300 
             hover:cursor-pointer"
              onClick={() => navigate("/crm/all_leads_task")}
            >
              <div class="text-sm/6 font-medium text-gray-500">Tasks</div>
              <div class="w-full flex justify-center items-center gap-x-2 text-3xl/10 font-medium tracking-tight text-gray-900">
                <span class="inline-flex shrink-0 items-center rounded-full bg-purple-300 px-1.5 py-1.5 text-xs font-medium text-purple-700 ring-1 ring-purple-600/20 ring-inset">
                  <QueueListIcon className="h-6 w-6 text-purple-600" />
                </span>
                {allDatasCount?.taskTotalCount}
              </div>
            </div>
          </div>

          <div className="w-full overflow-hidden">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-1 lg:grid-cols-2 w-full mt-5 ">
              <div className="w-full col-span-1 sm:col-span-1">
                <div className="mt-4 bg-white rounded-lg p-0  h-96 overflow-y-scroll custom-scrollbar">
                  <h2 className="text-base col-span-1 font-semibold text-gray-900 z-50 p-2  z-30">
                    <div className="flex justify-between items-center">
                      {/* Left Side: Icon and Leads */}
                      <span className="flex items-center gap-4">
                        <span className="inline-flex shrink-0 items-center rounded-full bg-yellow-300 px-1.5 py-1.5 text-xs font-medium text-yellow-700 ring-1 ring-yellow-600/20 ring-inset">
                          <ChartBarIcon className="h-6 w-6 text-yellow-600" />
                        </span>
                        <span className="text-sm font-medium text-gray-900">
                          Leads
                        </span>
                      </span>

                      {/* Right Side: Arrow Icon */}
                      <ArrowRightIcon
                        className="h-6 w-6 text-gray-600 cursor-pointer transition-all duration-300 hover:text-gray-900 hover:scale-110"
                        onClick={() => navigate("/crm/lead")}
                      />
                    </div>
                  </h2>
                  <div class="grid grid-cols-1 p-2 flex sm:grid-cols-2 items-center  sticky top-0 bg-white">
                    <div class="overflow-x-auto scroll-hidden col-span-2 sm:grid grid-cols-1 md:grid-cols-2 sm:block">
                      <div class="">
                        <nav class="-mb-px flex space-x-8">
                          <button
                            onClick={() => setActiveTabsForLeads("completed")}
                            className={`flex ${
                              activeTabsForLead === "completed"
                                ? "border-b-2 border-indigo-500 text-indigo-600"
                                : "text-gray-500"
                            } px-1 py-4 text-sm font-medium whitespace-nowrap text-gray-500 hover:border-gray-200 hover:text-gray-700`}
                          >
                            Completed
                            <span class="ml-3 rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-900 md:inline-block">
                              {allLeadDatas?.lead_counts?.Completed}
                            </span>
                          </button>

                          <button
                            onClick={() => setActiveTabsForLeads("converted")}
                            className={`flex ${
                              activeTabsForLead === "converted"
                                ? "border-b-2 border-indigo-500 text-indigo-600"
                                : "text-gray-500"
                            } px-1 py-4 text-sm font-medium whitespace-nowrap text-gray-500 hover:border-gray-200 hover:text-gray-700`}
                          >
                            Converted
                            <span class="ml-3 rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-900 md:inline-block">
                              {allLeadDatas?.lead_counts?.Converted}
                            </span>
                          </button>

                          <button
                            onClick={() => setActiveTabsForLeads("pending")}
                            className={`flex ${
                              activeTabsForLead === "pending"
                                ? "border-b-2 border-indigo-500 text-indigo-600"
                                : "text-gray-500"
                            } px-1 py-4 text-sm font-medium whitespace-nowrap text-gray-500 hover:border-gray-200 hover:text-gray-700`}
                          >
                            Pending
                            <span class="ml-3 rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-900 md:inline-block">
                              {allLeadDatas?.lead_counts?.Pending}
                            </span>
                          </button>

                          <button
                            onClick={() => setActiveTabsForLeads("inprogress")}
                            className={`flex ${
                              activeTabsForLead === "inprogress"
                                ? "border-b-2 border-indigo-500 text-indigo-600"
                                : "text-gray-500"
                            } px-1 py-4 text-sm font-medium whitespace-nowrap text-gray-500 hover:border-gray-200 hover:text-gray-700`}
                          >
                            In Progress
                            <span class="ml-3 rounded-full bg-indigo-100 px-2.5 py-0.5 text-xs font-medium text-gray-900 md:inline-block">
                              {allLeadDatas?.lead_counts?.In_Progress}
                            </span>
                          </button>
                        </nav>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 ">
                    {activeTabsForLead === "completed" && (
                      <>
                        {allLeadDatas?.completed?.length > 0 ? (
                          <div className="mt-6 border-t border-gray-100">
                            <div className="w-full px-4">
                              {/* Scrollable Table for Mobile */}
                              <div className="w-full overflow-x-auto sm:overflow-x-visible sm:max-h-[300px] sm:overflow-y-auto custom-scrollbar">
                                <table className="w-full min-w-[600px] table-auto text-left">
                                  <thead className="bg-white shadow-sm">
                                    <tr>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700">
                                        Lead Value
                                      </th>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700  sm:table-cell">
                                        Lead & Employee
                                      </th>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700 text-right">
                                        Actions
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {allLeadDatas?.completed?.map((lead) => (
                                      <tr
                                        key={lead?.id}
                                        className="border-b border-gray-200"
                                      >
                                        {/* Lead Value & City */}
                                        <td className="relative py-4 px-4 w-1/3 sm:w-auto">
                                          <div className="flex items-start gap-x-4">
                                            <CurrencyRupeeIcon className="w-4 h-4 mt-1 text-gray-500" />
                                            <div>
                                              <div className="text-sm font-medium text-gray-900">
                                                {lead?.lead_value
                                                  ? Number(
                                                      lead?.lead_value
                                                    ).toLocaleString()
                                                  : "0"}
                                              </div>
                                              <div className="mt-1 text-center px-2 py-1 text-xs font-medium rounded-md bg-green-100 text-green-700">
                                                {lead?.city || "N/A"}
                                              </div>
                                              <div className="mt-1 text-xs text-gray-500">
                                                Email:{" "}
                                                {lead?.email_address || "N/A"}
                                              </div>
                                            </div>
                                          </div>
                                        </td>

                                        {/* Lead & Employee */}
                                        <td className="hidden sm:table-cell py-4 px-4 w-1/3 sm:w-auto">
                                          <div className="text-sm text-gray-900">
                                            <span className="text-xs text-gray-500">
                                              Lead:{" "}
                                            </span>
                                            {lead?.name}
                                          </div>
                                          <div className="mt-1 text-xs text-gray-500">
                                            Employee:{" "}
                                            {lead?.lead_employee?.length > 0
                                              ? lead.lead_employee
                                                  .map((emp) => emp.name)
                                                  .join(", ")
                                              : "No employee assigned"}
                                          </div>
                                        </td>

                                        {/* Mobile-Friendly Lead & Employee */}
                                        <td className="sm:hidden py-4 px-4">
                                          <div className="text-sm text-gray-900">
                                            <span className="text-xs text-gray-500">
                                              Lead:{" "}
                                            </span>
                                            {lead?.name}
                                          </div>
                                          <div className="mt-1 text-xs text-gray-500">
                                            Employee:{" "}
                                            {lead?.lead_employee?.length > 0
                                              ? lead.lead_employee
                                                  .map((emp) => emp.name)
                                                  .join(", ")
                                              : "No employee assigned"}
                                          </div>
                                        </td>

                                        {/* Actions & Date */}
                                        <td className="py-4 px-4 text-right w-1/3 sm:w-auto">
                                          <div className="flex justify-end">
                                            <button
                                              onClick={() =>
                                                handleViewLead(lead.id_crypt)
                                              }
                                              className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
                                            >
                                              View Lead
                                            </button>
                                          </div>
                                          <div className="mt-1 text-xs text-gray-500">
                                            Date:{" "}
                                            <span className="text-gray-900">
                                              {lead?.created_at?.split(
                                                "T"
                                              )[0] || "N/A"}
                                            </span>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="flex justify-center items-center h-44 text-gray-500 text-md font-medium">
                            No Completed Leads Available
                          </div>
                        )}
                      </>
                    )}

                    {activeTabsForLead === "converted" && (
                      <>
                        {allLeadDatas?.converted?.length > 0 ? (
                          <div className="mt-6 border-t border-gray-100">
                            <div className="w-full px-4">
                              {/* Scrollable Table for Mobile */}
                              <div className="w-full overflow-x-auto sm:overflow-x-visible sm:max-h-[300px] sm:overflow-y-auto custom-scrollbar">
                                <table className="w-full min-w-[600px] table-auto text-left">
                                  <thead className="bg-white shadow-sm">
                                    <tr>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700">
                                        Lead Value
                                      </th>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700  sm:table-cell">
                                        Lead & Employee
                                      </th>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700 text-right">
                                        Actions
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {allLeadDatas?.converted?.map((lead) => (
                                      <tr
                                        key={lead?.id}
                                        className="border-b border-gray-200"
                                      >
                                        {/* Lead Value & City */}
                                        <td className="relative py-4 px-4 w-1/3 sm:w-auto">
                                          <div className="flex items-start gap-x-4">
                                            <CurrencyRupeeIcon className="w-4 h-4 mt-1 text-gray-500" />
                                            <div>
                                              <div className="text-sm font-medium text-gray-900">
                                                {lead?.lead_value
                                                  ? Number(
                                                      lead?.lead_value
                                                    ).toLocaleString()
                                                  : "0"}
                                              </div>
                                              <div className="mt-1 text-center px-2 py-1 text-xs font-medium rounded-md bg-green-100 text-green-700">
                                                {lead?.city || "N/A"}
                                              </div>
                                              <div className="mt-1 text-xs text-gray-500">
                                                Email:{" "}
                                                {lead?.email_address || "N/A"}
                                              </div>
                                            </div>
                                          </div>
                                        </td>

                                        {/* Lead & Employee */}
                                        <td className="hidden sm:table-cell py-4 px-4 w-1/3 sm:w-auto">
                                          <div className="text-sm text-gray-900">
                                            <span className="text-xs text-gray-500">
                                              Lead:{" "}
                                            </span>
                                            {lead?.name}
                                          </div>
                                          <div className="mt-1 text-xs text-gray-500">
                                            Employee:{" "}
                                            {lead?.lead_employee?.length > 0
                                              ? lead.lead_employee
                                                  .map((emp) => emp.name)
                                                  .join(", ")
                                              : "No employee assigned"}
                                          </div>
                                        </td>

                                        {/* Mobile-Friendly Lead & Employee */}
                                        <td className="sm:hidden py-4 px-4">
                                          <div className="text-sm text-gray-900">
                                            <span className="text-xs text-gray-500">
                                              Lead:{" "}
                                            </span>
                                            {lead?.name}
                                          </div>
                                          <div className="mt-1 text-xs text-gray-500">
                                            Employee:{" "}
                                            {lead?.lead_employee?.length > 0
                                              ? lead.lead_employee
                                                  .map((emp) => emp.name)
                                                  .join(", ")
                                              : "No employee assigned"}
                                          </div>
                                        </td>

                                        {/* Actions & Date */}
                                        <td className="py-4 px-4 text-right w-1/3 sm:w-auto">
                                          <div className="flex justify-end">
                                            <button
                                              onClick={() =>
                                                handleViewLead(lead.id_crypt)
                                              }
                                              className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
                                            >
                                              View Lead
                                            </button>
                                          </div>
                                          <div className="mt-1 text-xs text-gray-500">
                                            Date:{" "}
                                            <span className="text-gray-900">
                                              {lead?.created_at?.split(
                                                "T"
                                              )[0] || "N/A"}
                                            </span>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="flex justify-center items-center h-44 text-gray-500 text-md font-medium">
                            No Converted Leads Available
                          </div>
                        )}
                      </>
                    )}

                    {activeTabsForLead === "pending" && (
                      <>
                        {allLeadDatas?.pending?.length > 0 ? (
                          <div className="mt-6 border-t border-gray-100">
                            <div className="w-full px-4">
                              {/* Scrollable Table for Mobile */}
                              <div className="w-full overflow-x-auto sm:overflow-x-visible sm:max-h-[300px] sm:overflow-y-auto custom-scrollbar">
                                <table className="w-full min-w-[600px] table-auto text-left">
                                  <thead className="bg-white shadow-sm">
                                    <tr>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700">
                                        Lead Value
                                      </th>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700  sm:table-cell">
                                        Lead & Employee
                                      </th>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700 text-right">
                                        Actions
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {allLeadDatas?.pending?.map((lead) => (
                                      <tr
                                        key={lead?.id}
                                        className="border-b border-gray-200"
                                      >
                                        {/* Lead Value & City */}
                                        <td className="relative py-4 px-4 w-1/3 sm:w-auto">
                                          <div className="flex items-start gap-x-4">
                                            <CurrencyRupeeIcon className="w-4 h-4 mt-1 text-gray-500" />
                                            <div>
                                              <div className="text-sm font-medium text-gray-900">
                                                {lead?.lead_value
                                                  ? Number(
                                                      lead?.lead_value
                                                    ).toLocaleString()
                                                  : "0"}
                                              </div>
                                              <div className="mt-1 text-center px-2 py-1 text-xs font-medium rounded-md bg-green-100 text-green-700">
                                                {lead?.city || "N/A"}
                                              </div>
                                              <div className="mt-1 text-xs text-gray-500">
                                                Email:{" "}
                                                {lead?.email_address || "N/A"}
                                              </div>
                                            </div>
                                          </div>
                                        </td>

                                        {/* Lead & Employee */}
                                        <td className="hidden sm:table-cell py-4 px-4 w-1/3 sm:w-auto">
                                          <div className="text-sm text-gray-900">
                                            <span className="text-xs text-gray-500">
                                              Lead:{" "}
                                            </span>
                                            {lead?.name}
                                          </div>
                                          <div className="mt-1 text-xs text-gray-500">
                                            Employee:{" "}
                                            {lead?.lead_employee?.length > 0
                                              ? lead.lead_employee
                                                  .map((emp) => emp.name)
                                                  .join(", ")
                                              : "No employee assigned"}
                                          </div>
                                        </td>

                                        {/* Mobile-Friendly Lead & Employee */}
                                        <td className="sm:hidden py-4 px-4">
                                          <div className="text-sm text-gray-900">
                                            <span className="text-xs text-gray-500">
                                              Lead:{" "}
                                            </span>
                                            {lead?.name}
                                          </div>
                                          <div className="mt-1 text-xs text-gray-500">
                                            Employee:{" "}
                                            {lead?.lead_employee?.length > 0
                                              ? lead.lead_employee
                                                  .map((emp) => emp.name)
                                                  .join(", ")
                                              : "No employee assigned"}
                                          </div>
                                        </td>

                                        {/* Actions & Date */}
                                        <td className="py-4 px-4 text-right w-1/3 sm:w-auto">
                                          <div className="flex justify-end">
                                            <button
                                              onClick={() =>
                                                handleViewLead(lead.id_crypt)
                                              }
                                              className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
                                            >
                                              View Lead
                                            </button>
                                          </div>
                                          <div className="mt-1 text-xs text-gray-500">
                                            Date:{" "}
                                            <span className="text-gray-900">
                                              {lead?.created_at?.split(
                                                "T"
                                              )[0] || "N/A"}
                                            </span>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="flex justify-center items-center h-44 text-gray-500 text-md font-medium">
                            No Pending Leads Available
                          </div>
                        )}
                      </>
                    )}

                    {activeTabsForLead === "inprogress" && (
                      <>
                        {allLeadDatas?.inprogress?.length > 0 ? (
                          <div className="mt-6 border-t border-gray-100">
                            <div className="w-full px-4">
                              {/* Scrollable Table for Mobile */}
                              <div className="w-full overflow-x-auto sm:overflow-x-visible sm:max-h-[300px] sm:overflow-y-auto custom-scrollbar">
                                <table className="w-full min-w-[600px] table-auto text-left">
                                  <thead className="bg-white shadow-sm">
                                    <tr>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700">
                                        Lead Value
                                      </th>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700  sm:table-cell">
                                        Lead & Employee
                                      </th>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700 text-right">
                                        Actions
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {allLeadDatas?.inprogress?.map((lead) => (
                                      <tr
                                        key={lead?.id}
                                        className="border-b border-gray-200"
                                      >
                                        {/* Lead Value & City */}
                                        <td className="relative py-4 px-4 w-1/3 sm:w-auto">
                                          <div className="flex items-start gap-x-4">
                                            <CurrencyRupeeIcon className="w-4 h-4 mt-1 text-gray-500" />
                                            <div>
                                              <div className="text-sm font-medium text-gray-900">
                                                {lead?.lead_value
                                                  ? Number(
                                                      lead?.lead_value
                                                    ).toLocaleString()
                                                  : "0"}
                                              </div>
                                              <div className="mt-1 text-center px-2 py-1 text-xs font-medium rounded-md bg-green-100 text-green-700">
                                                {lead?.city || "N/A"}
                                              </div>
                                              <div className="mt-1 text-xs text-gray-500">
                                                Email:{" "}
                                                {lead?.email_address || "N/A"}
                                              </div>
                                            </div>
                                          </div>
                                        </td>

                                        {/* Lead & Employee */}
                                        <td className="hidden sm:table-cell py-4 px-4 w-1/3 sm:w-auto">
                                          <div className="text-sm text-gray-900">
                                            <span className="text-xs text-gray-500">
                                              Lead:{" "}
                                            </span>
                                            {lead?.name}
                                          </div>
                                          <div className="mt-1 text-xs text-gray-500">
                                            Employee:{" "}
                                            {lead?.lead_employee?.length > 0
                                              ? lead.lead_employee
                                                  .map((emp) => emp.name)
                                                  .join(", ")
                                              : "No employee assigned"}
                                          </div>
                                        </td>

                                        {/* Mobile-Friendly Lead & Employee */}
                                        <td className="sm:hidden py-4 px-4">
                                          <div className="text-sm text-gray-900">
                                            <span className="text-xs text-gray-500">
                                              Lead:{" "}
                                            </span>
                                            {lead?.name}
                                          </div>
                                          <div className="mt-1 text-xs text-gray-500">
                                            Employee:{" "}
                                            {lead?.lead_employee?.length > 0
                                              ? lead.lead_employee
                                                  .map((emp) => emp.name)
                                                  .join(", ")
                                              : "No employee assigned"}
                                          </div>
                                        </td>

                                        {/* Actions & Date */}
                                        <td className="py-4 px-4 text-right w-1/3 sm:w-auto">
                                          <div className="flex justify-end">
                                            <button
                                              onClick={() =>
                                                handleViewLead(lead.id_crypt)
                                              }
                                              className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
                                            >
                                              View Lead
                                            </button>
                                          </div>
                                          <div className="mt-1 text-xs text-gray-500">
                                            Date:{" "}
                                            <span className="text-gray-900">
                                              {lead?.created_at?.split(
                                                "T"
                                              )[0] || "N/A"}
                                            </span>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="flex justify-center items-center h-44 text-gray-500 text-md font-medium">
                            No In-progress Leads Available
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="w-full col-span-1 sm:col-span-1">
                <div className="mt-4 bg-white rounded-lg p-0 h-96 overflow-y-scroll custom-scrollbar">
                  <h2 className="text-base col-span-1 font-semibold text-gray-900 z-50 p-2  z-30">
                    <div className="flex justify-between items-center">
                      {/* Left Side: Icon and Leads */}
                      <span className="flex gap-4 items-center">
                        <span class="inline-flex shrink-0 items-center rounded-full bg-indigo-300 px-1.5 py-1.5 text-xs font-medium text-indigo-700 ring-1 ring-indigo-600/20 ring-inset">
                          <ListBulletIcon className="h-6 w-6 text-indigo-800" />
                        </span>
                        <h4>Quotations</h4>
                      </span>

                      {/* Right Side: Arrow Icon */}
                      <ArrowRightIcon
                        className="h-6 w-6 text-gray-600 cursor-pointer transition-all duration-300 hover:text-gray-900 hover:scale-110"
                        onClick={() => navigate("/crm/quotation")}
                      />
                    </div>
                  </h2>
                  <div class="grid grid-cols-1 flex p-2 sm:grid-cols-2 items-center p-4 sticky top-0 bg-white z-30">
                    {/* <h2 class="text-base col-span-1 font-semibold text-gray-900">
                      <span className="flex gap-4 items-center">
                        <span class="inline-flex shrink-0 items-center rounded-full bg-indigo-300 px-1.5 py-1.5 text-xs font-medium text-indigo-700 ring-1 ring-indigo-600/20 ring-inset">
                          <ListBulletIcon className="h-6 w-6 text-indigo-800" />
                        </span>
                        <h4>Quotations</h4>
                      </span>
                    </h2> */}

                    <div class="overflow-scroll col-span-2 sm:overflow-hidden  sm:grid grid-cols-1 md:grid-cols-2 sm:block">
                      <div class="">
                        <nav class="-mb-px flex space-x-8">
                          <button
                            onClick={() =>
                              setActiveTabsForQuotation("approved")
                            }
                            className={`flex ${
                              activeTabsForQuotation === "approved"
                                ? "border-b-2 border-indigo-500 text-indigo-600"
                                : "text-gray-500"
                            } px-1 py-4 text-sm font-medium whitespace-nowrap text-gray-500 hover:border-gray-200 hover:text-gray-700`}
                          >
                            Approved
                            <span class="ml-3 rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-900 md:inline-block">
                              {allQuotationDatas?.quotation_counts?.Approved}
                            </span>
                          </button>
                          <button
                            onClick={() => setActiveTabsForQuotation("pending")}
                            className={`flex ${
                              activeTabsForQuotation === "pending"
                                ? "border-b-2 border-indigo-500 text-indigo-600"
                                : "text-gray-500"
                            } px-1 py-4 text-sm font-medium whitespace-nowrap text-gray-500 hover:border-gray-200 hover:text-gray-700`}
                          >
                            Pending
                            <span class="ml-3 rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-900 md:inline-block">
                              {allQuotationDatas?.quotation_counts?.Pending}
                            </span>
                          </button>
                          <button
                            onClick={() =>
                              setActiveTabsForQuotation("rejected")
                            }
                            className={`flex ${
                              activeTabsForQuotation === "rejected"
                                ? "border-b-2 border-indigo-500 text-indigo-600"
                                : "text-gray-500"
                            } px-1 py-4 text-sm font-medium whitespace-nowrap text-gray-500 hover:border-gray-200 hover:text-gray-700`}
                          >
                            Rejected
                            <span class="ml-3 rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-900 md:inline-block">
                              {allQuotationDatas?.quotation_counts?.Rejected}
                            </span>
                          </button>
                        </nav>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4">
                    {activeTabsForQuotation === "approved" && (
                      <>
                        {allQuotationDatas?.approved?.length > 0 ? (
                          <div className="mt-6 border-t border-gray-100">
                            <div className="w-full px-4">
                              {/* Scrollable Table for Mobile */}
                              <div className="w-full overflow-x-auto sm:overflow-x-visible sm:max-h-[300px] sm:overflow-y-auto custom-scrollbar">
                                <table className="w-full min-w-[600px] table-auto text-left z-0">
                                  <thead className="bg-white shadow-sm">
                                    <tr>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700">
                                        Total Amount
                                      </th>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700  sm:table-cell">
                                        Lead & Employee
                                      </th>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700 text-right">
                                        Actions
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {allQuotationDatas?.approved?.map(
                                      (quotation) => (
                                        <tr
                                          key={quotation.id}
                                          className="border-b border-gray-200"
                                        >
                                          {/* Quotation Amount & Status */}
                                          <td className="relative py-4 px-4 w-1/3 sm:w-auto">
                                            <div className="flex items-start gap-x-4">
                                              <CurrencyRupeeIcon className="w-4 h-4 mt-1 text-gray-500" />
                                              <div>
                                                <div className="text-sm font-medium text-gray-900">
                                                  {quotation.total_amount
                                                    ? Number(
                                                        quotation.total_amount
                                                      ).toLocaleString()
                                                    : "0"}
                                                </div>
                                                <div className="mt-1 text-center px-2 py-1 text-xs font-medium rounded-md bg-green-100 text-green-700">
                                                  {quotation.quotation_status
                                                    ?.name || "N/A"}
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Validity:{" "}
                                                  {quotation.quotation_validity_date ||
                                                    "N/A"}
                                                </div>
                                              </div>
                                            </div>
                                          </td>

                                          {/* Lead & Employee (Desktop View) */}
                                          <td className="hidden sm:table-cell py-4 px-4 w-1/3 sm:w-auto">
                                            <div className="text-sm text-gray-900">
                                              <span className="text-xs text-gray-500">
                                                Lead:{" "}
                                              </span>
                                              {quotation.lead?.name || "N/A"}
                                            </div>
                                            <div className="mt-1 text-xs text-gray-500">
                                              Employee:{" "}
                                              {quotation.employee?.name ||
                                                "No employee assigned"}
                                            </div>
                                          </td>

                                          {/* Lead & Employee (Mobile View) */}
                                          <td className="sm:hidden py-4 px-4">
                                            <div className="text-sm text-gray-900">
                                              <span className="text-xs text-gray-500">
                                                Lead:{" "}
                                              </span>
                                              {quotation.lead?.name || "N/A"}
                                            </div>
                                            <div className="mt-1 text-xs text-gray-500">
                                              Employee:{" "}
                                              {quotation.employee?.name ||
                                                "No employee assigned"}
                                            </div>
                                          </td>

                                          {/* Actions & Date */}
                                          <td className="py-4 px-4 text-right w-1/3 sm:w-auto">
                                            <div className="flex justify-end">
                                              <button
                                                onClick={() =>
                                                  handleViewQuotation(
                                                    quotation.id_crypt
                                                  )
                                                }
                                                className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
                                              >
                                                View Quotation
                                              </button>
                                            </div>
                                            <div className="mt-1 text-xs text-gray-500">
                                              Date:{" "}
                                              <span className="text-gray-900">
                                                {quotation.quotation_date ||
                                                  "N/A"}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="flex justify-center items-center h-44 text-gray-500 text-md font-medium">
                            No Quotations Approved
                          </div>
                        )}
                      </>
                    )}

                    {activeTabsForQuotation === "pending" && (
                      <>
                        {allQuotationDatas?.pending?.length > 0 ? (
                          <div className="mt-6 border-t border-gray-100">
                            <div className="w-full px-4">
                              {/* Scrollable Table for Mobile */}
                              <div className="w-full overflow-x-auto sm:overflow-x-visible sm:max-h-[300px] sm:overflow-y-auto custom-scrollbar">
                                <table className="w-full min-w-[600px] table-auto text-left">
                                  <thead className="bg-white shadow-sm">
                                    <tr>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700">
                                        Total Amount
                                      </th>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700  sm:table-cell">
                                        Lead & Employee
                                      </th>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700 text-right">
                                        Actions
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {allQuotationDatas?.pending?.map(
                                      (quotation) => (
                                        <tr
                                          key={quotation.id}
                                          className="border-b border-gray-200"
                                        >
                                          {/* Quotation Amount & Status */}
                                          <td className="relative py-4 px-4 w-1/3 sm:w-auto">
                                            <div className="flex items-start gap-x-4">
                                              <CurrencyRupeeIcon className="w-4 h-4 mt-1 text-gray-500" />
                                              <div>
                                                <div className="text-sm font-medium text-gray-900">
                                                  {quotation.total_amount
                                                    ? Number(
                                                        quotation.total_amount
                                                      ).toLocaleString()
                                                    : "0"}
                                                </div>
                                                <div className="mt-1 text-center px-2 py-1 text-xs font-medium rounded-md bg-yellow-100 text-yellow-700">
                                                  {quotation.quotation_status
                                                    ?.name || "N/A"}
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Validity:{" "}
                                                  {quotation.quotation_validity_date ||
                                                    "N/A"}
                                                </div>
                                              </div>
                                            </div>
                                          </td>

                                          {/* Lead & Employee (Desktop View) */}
                                          <td className="hidden sm:table-cell py-4 px-4 w-1/3 sm:w-auto">
                                            <div className="text-sm text-gray-900">
                                              <span className="text-xs text-gray-500">
                                                Lead:{" "}
                                              </span>
                                              {quotation.lead?.name || "N/A"}
                                            </div>
                                            <div className="mt-1 text-xs text-gray-500">
                                              Employee:{" "}
                                              {quotation.employee?.name ||
                                                "No employee assigned"}
                                            </div>
                                          </td>

                                          {/* Lead & Employee (Mobile View) */}
                                          <td className="sm:hidden py-4 px-4">
                                            <div className="text-sm text-gray-900">
                                              <span className="text-xs text-gray-500">
                                                Lead:{" "}
                                              </span>
                                              {quotation.lead?.name || "N/A"}
                                            </div>
                                            <div className="mt-1 text-xs text-gray-500">
                                              Employee:{" "}
                                              {quotation.employee?.name ||
                                                "No employee assigned"}
                                            </div>
                                          </td>

                                          {/* Actions & Date */}
                                          <td className="py-4 px-4 text-right w-1/3 sm:w-auto">
                                            <div className="flex justify-end">
                                              <button
                                                onClick={() =>
                                                  handleViewQuotation(
                                                    quotation.id_crypt
                                                  )
                                                }
                                                className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
                                              >
                                                View Quotation
                                              </button>
                                            </div>
                                            <div className="mt-1 text-xs text-gray-500">
                                              Date:{" "}
                                              <span className="text-gray-900">
                                                {quotation.quotation_date ||
                                                  "N/A"}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="flex justify-center items-center h-44 text-gray-500 text-md font-medium">
                            No Quotations Pending
                          </div>
                        )}
                      </>
                    )}

                    {activeTabsForQuotation === "rejected" && (
                      <>
                        {allQuotationDatas?.rejected?.length > 0 ? (
                          <div className="mt-6 border-t border-gray-100">
                            <div className="w-full px-4">
                              {/* Scrollable Table for Mobile */}
                              <div className="w-full overflow-x-auto sm:overflow-x-visible sm:max-h-[300px] sm:overflow-y-auto custom-scrollbar">
                                <table className="w-full min-w-[600px] table-auto text-left">
                                  <thead className="bg-white shadow-sm">
                                    <tr>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700">
                                        Total Amount
                                      </th>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700  sm:table-cell">
                                        Lead & Employee
                                      </th>
                                      <th className="py-3 px-4 text-sm font-medium text-gray-700 text-right">
                                        Actions
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {allQuotationDatas?.rejected?.map(
                                      (quotation) => (
                                        <tr
                                          key={quotation.id}
                                          className="border-b border-gray-200"
                                        >
                                          {/* Quotation Amount & Status */}
                                          <td className="relative py-4 px-4 w-1/3 sm:w-auto">
                                            <div className="flex items-start gap-x-4">
                                              <CurrencyRupeeIcon className="w-4 h-4 mt-1 text-gray-500" />
                                              <div>
                                                <div className="text-sm font-medium text-gray-900">
                                                  {quotation.total_amount
                                                    ? Number(
                                                        quotation.total_amount
                                                      ).toLocaleString()
                                                    : "0"}
                                                </div>
                                                <div className="mt-1 text-center px-2 py-1 text-xs font-medium rounded-md bg-red-100 text-red-700">
                                                  {quotation.quotation_status
                                                    ?.name || "N/A"}
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Validity:{" "}
                                                  {quotation.quotation_validity_date ||
                                                    "N/A"}
                                                </div>
                                              </div>
                                            </div>
                                          </td>

                                          {/* Lead & Employee (Desktop View) */}
                                          <td className="hidden sm:table-cell py-4 px-4 w-1/3 sm:w-auto">
                                            <div className="text-sm text-gray-900">
                                              <span className="text-xs text-gray-500">
                                                Lead:{" "}
                                              </span>
                                              {quotation.lead?.name || "N/A"}
                                            </div>
                                            <div className="mt-1 text-xs text-gray-500">
                                              Employee:{" "}
                                              {quotation.employee?.name ||
                                                "No employee assigned"}
                                            </div>
                                          </td>

                                          {/* Lead & Employee (Mobile View) */}
                                          <td className="sm:hidden py-4 px-4">
                                            <div className="text-sm text-gray-900">
                                              <span className="text-xs text-gray-500">
                                                Lead:{" "}
                                              </span>
                                              {quotation.lead?.name || "N/A"}
                                            </div>
                                            <div className="mt-1 text-xs text-gray-500">
                                              Employee:{" "}
                                              {quotation.employee?.name ||
                                                "No employee assigned"}
                                            </div>
                                          </td>

                                          {/* Actions & Date */}
                                          <td className="py-4 px-4 text-right w-1/3 sm:w-auto">
                                            <div className="flex justify-end">
                                              <button
                                                onClick={() =>
                                                  handleViewQuotation(
                                                    quotation.id_crypt
                                                  )
                                                }
                                                className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
                                              >
                                                View Quotation
                                              </button>
                                            </div>
                                            <div className="mt-1 text-xs text-gray-500">
                                              Date:{" "}
                                              <span className="text-gray-900">
                                                {quotation.quotation_date ||
                                                  "N/A"}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="flex justify-center items-center h-44 text-gray-500 text-md font-medium">
                            No Quotations Rejected
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* end */}

          {/* Graph */}

          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 mt-5">
            <div>
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="w-full p-6 bg-white rounded-lg shadow-md"
              >
                <h2 className="text-sm sm:text-md font-semibold text-gray-800 mb-4">
                  Leads Overview
                </h2>

                <div
                  className={`grid gap-4 items-center mb-4 ${
                    leadFilter.select_period === "custom"
                      ? "grid-cols-1 sm:grid-cols-2 md:grid-cols-3"
                      : "grid-cols-1 md:grid-cols-3"
                  }`}
                >
                  <div className="w-full min-w-0">
                    <select
                      className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-400"
                      name="select_period"
                      value={leadFilter.select_period}
                      onChange={handleChangeForLeadFilter}
                    >
                      <option value="">Select Period</option>
                      <option value="today">Today</option>
                      <option value="yesterday">Yesterday</option>
                      <option value="this_week">This Week</option>
                      <option value="last_week">Last Week</option>
                      <option value="this_month">This Month</option>
                      <option value="last_month">Last Month</option>
                      <option value="this_financial_year">
                        This Financial Year
                      </option>
                      <option value="this_quarter">This Quarter Year</option>
                      <option value="last_quarter">Last Quarter Year</option>
                      <option value="custom">Custom</option>
                    </select>
                  </div>

                  {leadFilter.select_period !== "custom" ? (
                    <div className="grid grid-cols-2 gap-4 w-full md:col-span-2">
                      <button
                        className="w-full px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all"
                        onClick={handleSubmitForLeadFilter}
                      >
                        Submit
                      </button>
                      <button
                        className="w-full px-4 py-2 text-sm font-medium text-white bg-gray-800 rounded-md shadow-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-400 transition-all"
                        onClick={handleResetForLeadFilter}
                      >
                        Reset
                      </button>
                    </div>
                  ) : (
                    <>
                      <div className="w-full min-w-0">
                        <input
                          type="date"
                          name="start_date"
                          className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-400"
                          value={leadFilter.start_date}
                          onChange={handleChangeForLeadFilter}
                        />
                      </div>

                      <div className="w-full min-w-0">
                        <input
                          type="date"
                          name="end_date"
                          className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-400"
                          value={leadFilter.end_date}
                          onChange={handleChangeForLeadFilter}
                        />
                      </div>

                      <div className="grid grid-cols-2 gap-4 w-full col-span-1 sm:col-span-2 md:col-span-3">
                        <button
                          className="w-full px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all"
                          onClick={handleSubmitForLeadFilter}
                        >
                          Submit
                        </button>
                        <button
                          className="w-full px-4 py-2 text-sm font-medium text-white bg-gray-800 rounded-md shadow-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-400 transition-all"
                          onClick={handleResetForLeadFilter}
                        >
                          Reset
                        </button>
                      </div>
                    </>
                  )}
                </div>

                {allLeadDatas?.leads?.length === 0 ? (
                  <div
                    style={{
                      height: 350,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <p
                      style={{
                        color: "#6B7280",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                    >
                      No data available to display.
                    </p>
                  </div>
                ) : (
                  <ResponsiveContainer width="100%" height={350}>
                    <BarChart
                      data={allLeadDatas?.leads}
                      margin={{ top: 20, right: 20, left: 0, bottom: 5 }}
                      barSize={10}
                    >
                      <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
                      <XAxis
                        dataKey="name"
                        tick={{ fill: "#6B7280", fontSize: 12 }}
                      />
                      <YAxis tick={{ fill: "#6B7280", fontSize: 12 }} />
                      <Tooltip
                        content={<CustomTooltip />}
                        cursor={{ fill: "#F3F4F6" }}
                      />
                      <Legend />
                      <Bar
                        dataKey="lead_value"
                        fill="url(#colorUv)"
                        radius={[8, 8, 0, 0]}
                        label={({ x, y, value }) => {
                          const formattedValue =
                            value >= 1000000
                              ? `${(value / 1000000).toFixed(1)}M`
                              : value >= 1000
                              ? `${(value / 1000).toFixed(1)}K`
                              : value;

                          return (
                            <text
                              x={x + 15}
                              y={y - 10}
                              fill="#6B7280"
                              fontSize={12}
                              fontWeight="bold"
                              transform={`rotate(-45, ${x + 15}, ${y - 10})`}
                              textAnchor="middle"
                            >
                              {formattedValue}
                            </text>
                          );
                        }}
                      />
                      <defs>
                        <linearGradient
                          id="colorUv"
                          x1="0"
                          y1="0"
                          x2="0"
                          y2="1"
                        >
                          <stop
                            offset="5%"
                            stopColor="#4F46E5"
                            stopOpacity={0.9}
                          />
                          <stop
                            offset="95%"
                            stopColor="#6366F1"
                            stopOpacity={0.3}
                          />
                        </linearGradient>
                      </defs>
                    </BarChart>
                  </ResponsiveContainer>
                )}
              </motion.div>
            </div>

            <div>
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="w-full p-6 bg-white rounded-lg shadow-md"
              >
                <h2 className="text-sm sm:text-md font-semibold text-gray-800 mb-4">
                  Customer Overview
                </h2>

                <div
                  className={`grid gap-4 ${
                    customerFilter.select_period === "custom"
                      ? "grid-cols-1 sm:grid-cols-2 md:grid-cols-3"
                      : "grid-cols-1 md:grid-cols-3"
                  } mb-4`}
                >
                  <div className="col-span-1">
                    <select
                      className="w-full min-w-0 px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-400"
                      name="select_period"
                      value={customerFilter.select_period}
                      onChange={handleChangeForCustomerFilter}
                    >
                      <option value="">Select Period</option>
                      <option value="today">Today</option>
                      <option value="yesterday">Yesterday</option>
                      <option value="this_week">This Week</option>
                      <option value="last_week">Last Week</option>
                      <option value="this_month">This Month</option>
                      <option value="last_month">Last Month</option>
                      <option value="this_financial_year">
                        This Financial Year
                      </option>
                      <option value="this_quarter">This Quarter Year</option>
                      <option value="last_quarter">Last Quarter Year</option>
                      <option value="custom">Custom</option>
                    </select>
                  </div>

                  {customerFilter.select_period === "custom" ? (
                    <>
                      <div className="col-span-1">
                        <input
                          type="date"
                          name="start_date"
                          className="w-full min-w-0 px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-400"
                          value={customerFilter.start_date}
                          onChange={handleChangeForCustomerFilter}
                        />
                      </div>
                      <div className="col-span-1">
                        <input
                          type="date"
                          name="end_date"
                          className="w-full min-w-0 px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-400"
                          value={customerFilter.end_date}
                          onChange={handleChangeForCustomerFilter}
                        />
                      </div>

                      <div className="col-span-1 sm:col-span-2 md:col-span-3 grid grid-cols-2 gap-4">
                        <button
                          className="w-full min-w-0 px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all"
                          onClick={handleSubmitForCustomerFilter}
                        >
                          Submit
                        </button>
                        <button
                          className="w-full min-w-0 px-4 py-2 text-sm font-medium text-white bg-gray-800 rounded-md shadow-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-400 transition-all"
                          onClick={handleResetForCustomerFilter}
                        >
                          Reset
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="col-span-1 md:col-span-2 lg:col-span-2 grid grid-cols-2 gap-4 p-1">
                      <button
                        className="w-full min-w-0 px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all"
                        onClick={handleSubmitForCustomerFilter}
                      >
                        Submit
                      </button>
                      <button
                        className="w-full min-w-0 px-4 py-2 text-sm font-medium text-white bg-gray-800 rounded-md shadow-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-400 transition-all"
                        onClick={handleResetForCustomerFilter}
                      >
                        Reset
                      </button>
                    </div>
                  )}
                </div>

                {customerChartData.length === 0 ? (
                  <div
                    style={{
                      height: 350,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <p
                      style={{
                        color: "#6B7280",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                    >
                      No customer data available to display.
                    </p>
                  </div>
                ) : (
                  <ResponsiveContainer width="100%" height={350}>
                    <BarChart
                      data={customerChartData}
                      margin={{ top: 20, right: 20, left: 0, bottom: 5 }}
                      barSize={10}
                    >
                      <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
                      <XAxis
                        dataKey="name"
                        tick={{ fill: "#6B7280", fontSize: 12 }}
                      />
                      <YAxis tick={{ fill: "#6B7280", fontSize: 12 }} />
                      <Tooltip cursor={{ fill: "#F3F4F6" }} />
                      <Legend />
                      <Bar
                        dataKey="Lead"
                        fill="#FF5733"
                        radius={[8, 8, 0, 0]}
                        label={{
                          position: "top",
                          fill: "#6B7280",
                          fontSize: 12,
                          fontWeight: "bold",
                          dy: -5,
                        }}
                      />
                      {/* <Bar
                        dataKey="Direct"
                        fill="#3498DB"
                        radius={[8, 8, 0, 0]}
                        label={{
                          position: "top",
                          fill: "#6B7280",
                          fontSize: 12,
                          fontWeight: "bold",
                          dy: -5,
                        }}
                      /> */}
                    </BarChart>
                  </ResponsiveContainer>
                )}
              </motion.div>
            </div>
          </div>

          {/* End */}

          <div className="w-full ">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-1 lg:grid-cols-2 w-full mt-5 ">
              <div className="w-full col-span-1 sm:col-span-1">
                <div className="mt-4 bg-white rounded-lg p-2 h-96 overflow-y-scroll custom-scrollbar">
                  <div className="w-full col-span-1 sm:col-span-1">
                    <div className="mt-4 bg-white rounded-lg p-0 h-96 custom-scrollbar">
                      {/* <h2 className="text-base col-span-1 font-semibold text-gray-900 z-50 p-2  z-30">
                        <div className="flex justify-between items-center">
                          
                          <span className="flex gap-4 items-center">
                            <span class="inline-flex shrink-0 items-center rounded-full bg-purple-300 px-1.5 py-1.5 text-xs font-medium text-purple-700 ring-1 ring-purple-600/20 ring-inset">
                              <QueueListIcon className="h-6 w-6 text-yelpurplelow-600" />
                            </span>
                            <h4>Tasks</h4>
                          </span>

                       
                          <ArrowRightIcon
                            className="h-6 w-6 text-gray-600 cursor-pointer transition-all duration-300 hover:text-gray-900 hover:scale-110"
                            onClick={() => navigate("/crm/all_leads_task")}
                          />
                        </div>
                      </h2> */}

                      <h2 className="text-base sticky top-0 col-span-1 font-semibold text-gray-900 z-50 p-2  z-30">
                        <div className="flex justify-between items-center">
                          {/* Left Side: Icon and Leads */}
                          <span className="flex gap-4 items-center">
                            <span class="inline-flex shrink-0 items-center rounded-full bg-purple-300 px-1.5 py-1.5 text-xs font-medium text-blue-700 ring-1 ring-blue-600/20 ring-inset">
                              <QueueListIcon className="h-6 w-6 text-purple-600" />
                            </span>
                            <h4>Tasks</h4>
                          </span>

                          {/* Right Side: Arrow Icon */}
                          <ArrowRightIcon
                            className="h-6 w-6 text-gray-600 cursor-pointer transition-all duration-300 hover:text-gray-900 hover:scale-110"
                            onClick={() => navigate("/crm/all_leads_task")}
                          />
                        </div>
                      </h2>
                      <div class="grid grid-cols-1 flex sm:grid-cols-2 items-center p-4 sticky top-0 bg-white z-10">
                        {/* <h2 class="text-base col-span-1 font-semibold text-gray-900">
                          <span className="flex gap-4 items-center">
                            <span class="inline-flex shrink-0 items-center rounded-full bg-purple-300 px-1.5 py-1.5 text-xs font-medium text-purple-700 ring-1 ring-purple-600/20 ring-inset">
                              <QueueListIcon className="h-6 w-6 text-yelpurplelow-600" />
                            </span>
                            <h4>Tasks</h4>
                          </span>
                        </h2> */}

                        <div class="overflow-scroll col-span-2 sm:overflow-hidden  sm:grid grid-cols-1 md:grid-cols-2 sm:block">
                          <div class="">
                            <nav class="-mb-px flex space-x-8">
                              <button
                                onClick={() =>
                                  setActiveTabsForTask("completed")
                                }
                                className={`flex ${
                                  activeTabsForTask === "completed"
                                    ? "border-b-2 border-indigo-500 text-indigo-600"
                                    : "text-gray-500"
                                } px-1 py-4 text-sm font-medium whitespace-nowrap text-gray-500 hover:border-gray-200 hover:text-gray-700`}
                              >
                                Completed
                                <span class="ml-3 rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-900 md:inline-block">
                                  {allTaskDatas?.task_counts?.Completed}
                                </span>
                              </button>
                              <button
                                onClick={() => setActiveTabsForTask("pending")}
                                className={`flex ${
                                  activeTabsForTask === "pending"
                                    ? "border-b-2 border-indigo-500 text-indigo-600"
                                    : "text-gray-500"
                                } px-1 py-4 text-sm font-medium whitespace-nowrap text-gray-500 hover:border-gray-200 hover:text-gray-700`}
                              >
                                Pending
                                <span class="ml-3 rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-900 md:inline-block">
                                  {allTaskDatas?.task_counts?.Pending}
                                </span>
                              </button>
                              <button
                                onClick={() =>
                                  setActiveTabsForTask("inprogress")
                                }
                                className={`flex ${
                                  activeTabsForTask === "inprogress"
                                    ? "border-b-2 border-indigo-500 text-indigo-600"
                                    : "text-gray-500"
                                } px-1 py-4 text-sm font-medium whitespace-nowrap text-gray-500 hover:border-gray-200 hover:text-gray-700`}
                              >
                                In Progress
                                <span class="ml-3 rounded-full bg-indigo-100 px-2.5 py-0.5 text-xs font-medium text-gray-900 md:inline-block">
                                  {allTaskDatas?.task_counts?.In_Progress}
                                </span>
                              </button>
                              <button
                                onClick={() =>
                                  setActiveTabsForTask("notStarted")
                                }
                                className={`flex ${
                                  activeTabsForTask === "notStarted"
                                    ? "border-b-2 border-indigo-500 text-indigo-600"
                                    : "text-gray-500"
                                } px-1 py-4 text-sm font-medium whitespace-nowrap text-gray-500 hover:border-gray-200 hover:text-gray-700`}
                              >
                                Not Yet Started
                                <span class="ml-3 rounded-full bg-indigo-100 px-2.5 py-0.5 text-xs font-medium text-gray-900 md:inline-block">
                                  {allTaskDatas?.task_counts?.Not_Yet_Started}
                                </span>
                              </button>
                            </nav>
                          </div>
                        </div>
                      </div>
                      <div className="mt-4">
                        {activeTabsForTask === "completed" && (
                          <>
                            {allTaskDatas?.completed?.length > 0 ? (
                              <div className="mt-6 border-t border-gray-100">
                                <div className="w-full px-4">
                                  {/* Scrollable container for better mobile support */}
                                  <div className="w-full overflow-x-auto sm:overflow-x-visible sm:max-h-[400px] sm:overflow-y-auto custom-scrollbar">
                                    <table className="w-full min-w-[600px] table-auto text-left">
                                      <thead className="bg-white shadow-sm">
                                        <tr>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700">
                                            Task
                                          </th>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700  sm:table-cell">
                                            Lead & Employee
                                          </th>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700 text-right">
                                            Actions
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {allTaskDatas?.completed?.map(
                                          (task) => (
                                            <tr
                                              key={task.id}
                                              className="border-b border-gray-200"
                                            >
                                              {/* Task Name & Type */}
                                              <td className="relative py-4 px-4 w-1/3 sm:w-auto">
                                                <div className="flex items-start gap-x-4">
                                                  <CurrencyRupeeIcon className="w-4 h-4 mt-1 text-gray-500" />
                                                  <div>
                                                    <div className="text-sm font-medium text-gray-900">
                                                      {task.task_name}
                                                    </div>
                                                    <div
                                                      className={`mt-1 text-center px-2 py-1 text-xs font-medium rounded-md ${
                                                        task.task_type === "1"
                                                          ? "bg-green-100 text-green-700"
                                                          : "bg-blue-100 text-blue-700"
                                                      }`}
                                                    >
                                                      {task.task_type === "1"
                                                        ? "General"
                                                        : "Lead"}
                                                    </div>
                                                    <div className="mt-1 text-xs text-gray-500">
                                                      Priority:{" "}
                                                      {task.priority_name
                                                        ?.name || "N/A"}
                                                    </div>
                                                  </div>
                                                </div>
                                              </td>

                                              {/* Lead & Employee */}
                                              <td className="hidden sm:table-cell py-4 px-4 w-1/3 sm:w-auto">
                                                <div className="text-sm text-gray-900">
                                                  <span className="text-xs text-gray-500">
                                                    Lead:{" "}
                                                  </span>
                                                  {task.lead_name?.name ||
                                                    "N/A"}
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Employee:{" "}
                                                  {task.task_member?.length > 0
                                                    ? task.task_member
                                                        .map(
                                                          (member) =>
                                                            member.name
                                                        )
                                                        .join(", ")
                                                    : "No employee assigned"}
                                                </div>
                                              </td>

                                              {/* Mobile-Friendly View */}
                                              <td className="sm:hidden py-4 px-4">
                                                <div className="text-sm text-gray-900">
                                                  <span className="text-xs text-gray-500">
                                                    Lead:{" "}
                                                  </span>
                                                  {task.lead_name?.name ||
                                                    "N/A"}
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Employee:{" "}
                                                  {task.task_member?.length > 0
                                                    ? task.task_member
                                                        .map(
                                                          (member) =>
                                                            member.name
                                                        )
                                                        .join(", ")
                                                    : "No employee assigned"}
                                                </div>
                                              </td>

                                              {/* Actions & Date */}
                                              <td className="py-4 px-4 text-right w-1/3 sm:w-auto">
                                                <div className="flex justify-end">
                                                  <button
                                                    onClick={() =>
                                                      handleViewTask(
                                                        task.id_crypt
                                                      )
                                                    }
                                                    className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
                                                  >
                                                    View Task
                                                  </button>
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Completed on:{" "}
                                                  <span className="text-gray-900">
                                                    {task.end_date || "N/A"}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="flex justify-center items-center h-44 text-gray-500 text-md font-medium">
                                No Completed Tasks
                              </div>
                            )}
                          </>
                        )}

                        {activeTabsForTask === "pending" && (
                          <>
                            {allTaskDatas?.pending?.length > 0 ? (
                              <div className="mt-6 border-t border-gray-100">
                                <div className="w-full px-4">
                                  {/* Scrollable container for better mobile support */}
                                  <div className="w-full overflow-x-auto sm:overflow-x-visible sm:max-h-[400px] sm:overflow-y-auto custom-scrollbar">
                                    <table className="w-full min-w-[600px] table-auto text-left">
                                      <thead className="bg-white shadow-sm">
                                        <tr>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700">
                                            Task
                                          </th>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700  sm:table-cell">
                                            Lead & Employee
                                          </th>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700 text-right">
                                            Actions
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {allTaskDatas?.pending?.map((task) => (
                                          <tr
                                            key={task.id}
                                            className="border-b border-gray-200"
                                          >
                                            {/* Task Name & Type */}
                                            <td className="relative py-4 px-4 w-1/3 sm:w-auto">
                                              <div className="flex items-start gap-x-4">
                                                <CurrencyRupeeIcon className="w-4 h-4 mt-1 text-gray-500" />
                                                <div>
                                                  <div className="text-sm font-medium text-gray-900">
                                                    {task.task_name}
                                                  </div>
                                                  <div
                                                    className={`mt-1 text-center px-2 py-1 text-xs font-medium rounded-md ${
                                                      task.task_type === "1"
                                                        ? "bg-green-100 text-green-700"
                                                        : "bg-blue-100 text-blue-700"
                                                    }`}
                                                  >
                                                    {task.task_type === "1"
                                                      ? "General"
                                                      : "Lead"}
                                                  </div>
                                                  <div className="mt-1 text-xs text-gray-500">
                                                    Priority:{" "}
                                                    {task.priority_name?.name ||
                                                      "N/A"}
                                                  </div>
                                                </div>
                                              </div>
                                            </td>

                                            {/* Lead & Employee */}
                                            <td className="hidden sm:table-cell py-4 px-4 w-1/3 sm:w-auto">
                                              <div className="text-sm text-gray-900">
                                                <span className="text-xs text-gray-500">
                                                  Lead:{" "}
                                                </span>
                                                {task.lead_name?.name || "N/A"}
                                              </div>
                                              <div className="mt-1 text-xs text-gray-500">
                                                Employee:{" "}
                                                {task.task_member?.length > 0
                                                  ? task.task_member
                                                      .map(
                                                        (member) => member.name
                                                      )
                                                      .join(", ")
                                                  : "No employee assigned"}
                                              </div>
                                            </td>

                                            {/* Mobile-Friendly View */}
                                            <td className="sm:hidden py-4 px-4">
                                              <div className="text-sm text-gray-900">
                                                <span className="text-xs text-gray-500">
                                                  Lead:{" "}
                                                </span>
                                                {task.lead_name?.name || "N/A"}
                                              </div>
                                              <div className="mt-1 text-xs text-gray-500">
                                                Employee:{" "}
                                                {task.task_member?.length > 0
                                                  ? task.task_member
                                                      .map(
                                                        (member) => member.name
                                                      )
                                                      .join(", ")
                                                  : "No employee assigned"}
                                              </div>
                                            </td>

                                            {/* Actions & Date */}
                                            <td className="py-4 px-4 text-right w-1/3 sm:w-auto">
                                              <div className="flex justify-end">
                                                <button
                                                  onClick={() =>
                                                    handleViewTask(
                                                      task.id_crypt
                                                    )
                                                  }
                                                  className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
                                                >
                                                  View Task
                                                </button>
                                              </div>
                                              <div className="mt-1 text-xs text-gray-500">
                                                Due Date:{" "}
                                                <span className="text-gray-900">
                                                  {task.end_date || "N/A"}
                                                </span>
                                              </div>
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="flex justify-center items-center h-44 text-gray-500 text-md font-medium">
                                No Pending Tasks
                              </div>
                            )}
                          </>
                        )}

                        {activeTabsForTask === "inprogress" && (
                          <>
                            {allTaskDatas?.inprogress?.length > 0 ? (
                              <div className="mt-6 border-t border-gray-100">
                                <div className="w-full px-4">
                                  {/* Scrollable Table for Mobile */}
                                  <div className="w-full overflow-x-auto sm:overflow-x-visible sm:max-h-[400px] sm:overflow-y-auto custom-scrollbar">
                                    <table className="w-full min-w-[600px] table-auto text-left">
                                      <thead className="bg-white shadow-sm">
                                        <tr>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700">
                                            Task
                                          </th>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700  sm:table-cell">
                                            Lead & Employee
                                          </th>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700 text-right">
                                            Actions
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {allTaskDatas?.inprogress?.map(
                                          (task) => (
                                            <tr
                                              key={task.id}
                                              className="border-b border-gray-200"
                                            >
                                              {/* Task Name & Type */}
                                              <td className="relative py-4 px-4 w-1/3 sm:w-auto">
                                                <div className="flex items-start gap-x-4">
                                                  <CurrencyRupeeIcon className="w-4 h-4 mt-1 text-gray-500" />
                                                  <div>
                                                    <div className="text-sm font-medium text-gray-900">
                                                      {task.task_name}
                                                    </div>
                                                    <div
                                                      className={`mt-1 text-center px-2 py-1 text-xs font-medium rounded-md ${
                                                        task.task_type === "1"
                                                          ? "bg-green-100 text-green-700"
                                                          : "bg-blue-100 text-blue-700"
                                                      }`}
                                                    >
                                                      {task.task_type === "1"
                                                        ? "General"
                                                        : "Lead"}
                                                    </div>
                                                    <div className="mt-1 text-xs text-gray-500">
                                                      Priority:{" "}
                                                      {task.priority_name
                                                        ?.name || "N/A"}
                                                    </div>
                                                  </div>
                                                </div>
                                              </td>

                                              {/* Lead & Employee */}
                                              <td className="hidden sm:table-cell py-4 px-4 w-1/3 sm:w-auto">
                                                <div className="text-sm text-gray-900">
                                                  <span className="text-xs text-gray-500">
                                                    Lead:{" "}
                                                  </span>
                                                  {task.lead_name?.name ||
                                                    "N/A"}
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Employee:{" "}
                                                  {task.task_member?.length > 0
                                                    ? task.task_member
                                                        .map(
                                                          (member) =>
                                                            member.name
                                                        )
                                                        .join(", ")
                                                    : "No employee assigned"}
                                                </div>
                                              </td>

                                              {/* Mobile-Friendly View */}
                                              <td className="sm:hidden py-4 px-4">
                                                <div className="text-sm text-gray-900">
                                                  <span className="text-xs text-gray-500">
                                                    Lead:{" "}
                                                  </span>
                                                  {task.lead_name?.name ||
                                                    "N/A"}
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Employee:{" "}
                                                  {task.task_member?.length > 0
                                                    ? task.task_member
                                                        .map(
                                                          (member) =>
                                                            member.name
                                                        )
                                                        .join(", ")
                                                    : "No employee assigned"}
                                                </div>
                                              </td>

                                              {/* Actions & Date */}
                                              <td className="py-4 px-4 text-right w-1/3 sm:w-auto">
                                                <div className="flex justify-end">
                                                  <button
                                                    onClick={() =>
                                                      handleViewTask(
                                                        task.id_crypt
                                                      )
                                                    }
                                                    className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
                                                  >
                                                    View Task
                                                  </button>
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Due Date:{" "}
                                                  <span className="text-gray-900">
                                                    {task.end_date || "N/A"}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="flex justify-center items-center h-44 text-gray-500 text-md font-medium">
                                No Tasks In Progress
                              </div>
                            )}
                          </>
                        )}

                        {activeTabsForTask === "notStarted" && (
                          <>
                            {allTaskDatas?.notyetstarted?.length > 0 ? (
                              <div className="mt-6 border-t border-gray-100">
                                <div className="w-full px-4">
                                  {/* Scrollable Table for Mobile */}
                                  <div className="w-full overflow-x-auto sm:overflow-x-visible sm:max-h-[300px] sm:overflow-y-auto custom-scrollbar">
                                    <table className="w-full min-w-[600px] table-auto text-left">
                                      <thead className="bg-white shadow-sm">
                                        <tr>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700">
                                            Task
                                          </th>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700  sm:table-cell">
                                            Lead & Employee
                                          </th>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700 text-right">
                                            Actions
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {allTaskDatas?.notyetstarted?.map(
                                          (task) => (
                                            <tr
                                              key={task.id}
                                              className="border-b border-gray-200"
                                            >
                                              {/* Task Name & Type */}
                                              <td className="relative py-4 px-4 w-1/3 sm:w-auto">
                                                <div className="flex items-start gap-x-4">
                                                  <CurrencyRupeeIcon className="w-4 h-4 mt-1 text-gray-500" />
                                                  <div>
                                                    <div className="text-sm font-medium text-gray-900">
                                                      {task.task_name}
                                                    </div>
                                                    <div
                                                      className={`mt-1 text-center px-2 py-1 text-xs font-medium rounded-md ${
                                                        task.task_type === "1"
                                                          ? "bg-green-100 text-green-700"
                                                          : "bg-blue-100 text-blue-700"
                                                      }`}
                                                    >
                                                      {task.task_type === "1"
                                                        ? "General"
                                                        : "Lead"}
                                                    </div>
                                                    <div className="mt-1 text-xs text-gray-500">
                                                      Priority:{" "}
                                                      {task.priority_name
                                                        ?.name || "N/A"}
                                                    </div>
                                                  </div>
                                                </div>
                                              </td>

                                              {/* Lead & Employee */}
                                              <td className="hidden sm:table-cell py-4 px-4 w-1/3 sm:w-auto">
                                                <div className="text-sm text-gray-900">
                                                  <span className="text-xs text-gray-500">
                                                    Lead:{" "}
                                                  </span>
                                                  {task.lead_name?.name ||
                                                    "N/A"}
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Employee:{" "}
                                                  {task.task_member?.length > 0
                                                    ? task.task_member
                                                        .map(
                                                          (member) =>
                                                            member.name
                                                        )
                                                        .join(", ")
                                                    : "No employee assigned"}
                                                </div>
                                              </td>

                                              {/* Mobile-Friendly View */}
                                              <td className="sm:hidden py-4 px-4">
                                                <div className="text-sm text-gray-900">
                                                  <span className="text-xs text-gray-500">
                                                    Lead:{" "}
                                                  </span>
                                                  {task.lead_name?.name ||
                                                    "N/A"}
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Employee:{" "}
                                                  {task.task_member?.length > 0
                                                    ? task.task_member
                                                        .map(
                                                          (member) =>
                                                            member.name
                                                        )
                                                        .join(", ")
                                                    : "No employee assigned"}
                                                </div>
                                              </td>

                                              {/* Actions & Date */}
                                              <td className="py-4 px-4 text-right w-1/3 sm:w-auto">
                                                <div className="flex justify-end">
                                                  <button
                                                    onClick={() =>
                                                      handleViewTask(
                                                        task.id_crypt
                                                      )
                                                    }
                                                    className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
                                                  >
                                                    View Task
                                                  </button>
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  End Date:{" "}
                                                  <span className="text-gray-900">
                                                    {task.end_date || "N/A"}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="flex justify-center items-center h-44 text-gray-500 text-md font-medium">
                                No Tasks Not Yet Started
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full col-span-1 sm:col-span-1">
                <div className="mt-4 bg-white rounded-lg p-2 h-96 overflow-y-scroll sm:overflow-hidden custom-scrollbar">
                  <div className="w-full col-span-1 sm:col-span-1">
                    <div className="mt-4 bg-white rounded-lg p-0 h-96 overflow-y-scroll sm:overflow-hidden custom-scrollbar">
                      <h2 className="text-base col-span-1 font-semibold text-gray-900 z-50 p-2  z-30">
                        <div className="flex justify-between items-center">
                          {/* Left Side: Icon and Leads */}
                          <span className="flex gap-4 items-center">
                            <span class="inline-flex shrink-0 items-center rounded-full bg-blue-300 px-1.5 py-1.5 text-xs font-medium text-blue-700 ring-1 ring-blue-600/20 ring-inset">
                              <Users className="h-6 w-6 text-blue-600" />
                            </span>
                            <h4>Employees</h4>
                          </span>

                          {/* Right Side: Arrow Icon */}
                          <ArrowRightIcon
                            className="h-6 w-6 text-gray-600 cursor-pointer transition-all duration-300 hover:text-gray-900 hover:scale-110"
                            onClick={() => navigate("/crm/lead_employees")}
                          />
                        </div>
                      </h2>
                      <div class="grid grid-cols-1 flex sm:grid-cols-2 items-center p-4 sticky top-0 bg-white z-10">
                        {/* <h2 class="text-base col-span-1 font-semibold text-gray-900">
                          <span className="flex gap-4 items-center">
                            <span class="inline-flex shrink-0 items-center rounded-full bg-blue-300 px-1.5 py-1.5 text-xs font-medium text-blue-700 ring-1 ring-blue-600/20 ring-inset">
                              <Users className="h-6 w-6 text-blue-600" />
                            </span>
                            <h4>Employees</h4>
                          </span>
                        </h2> */}

                        <div class="overflow-scroll col-span-2 sm:overflow-hidden  sm:grid grid-cols-1 md:grid-cols-2 sm:block">
                          <div class="">
                            <nav class="-mb-px flex space-x-8">
                              <button
                                onClick={() =>
                                  setActiveTabsForEmployees("totalEmployees")
                                }
                                className={`flex ${
                                  activeTabsForEmployees === "totalEmployees"
                                    ? "border-b-2 border-indigo-500 text-indigo-600"
                                    : "text-gray-500"
                                } px-1 py-4 text-sm font-medium whitespace-nowrap text-gray-500 hover:border-gray-200 hover:text-gray-700`}
                              >
                                Total Employees
                                <span class="ml-3 rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-900 md:inline-block">
                                  {allEmployeeDatas.employee_count}
                                </span>
                              </button>
                              <button
                                onClick={() =>
                                  setActiveTabsForEmployees("leads")
                                }
                                className={`flex ${
                                  activeTabsForEmployees === "leads"
                                    ? "border-b-2 border-indigo-500 text-indigo-600"
                                    : "text-gray-500"
                                } px-1 py-4 text-sm font-medium whitespace-nowrap text-gray-500 hover:border-gray-200 hover:text-gray-700`}
                              >
                                Leads
                                <span class="ml-3 rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-900 md:inline-block">
                                  {allEmployeeDatas.employeeleaddetails
                                    ?.length || "0"}
                                </span>
                              </button>
                              <button
                                onClick={() =>
                                  setActiveTabsForEmployees("tasks")
                                }
                                className={`flex ${
                                  activeTabsForEmployees === "tasks"
                                    ? "border-b-2 border-indigo-500 text-indigo-600"
                                    : "text-gray-500"
                                } px-1 py-4 text-sm font-medium whitespace-nowrap text-gray-500 hover:border-gray-200 hover:text-gray-700`}
                              >
                                Tasks
                                <span class="ml-3 rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-900 md:inline-block">
                                  {allEmployeeDatas.employeetaskdetails
                                    ?.length || "0"}
                                </span>
                              </button>
                              <button
                                onClick={() =>
                                  setActiveTabsForEmployees("quotation")
                                }
                                className={`flex ${
                                  activeTabsForEmployees === "quotation"
                                    ? "border-b-2 border-indigo-500 text-indigo-600"
                                    : "text-gray-500"
                                } px-1 py-4 text-sm font-medium whitespace-nowrap text-gray-500 hover:border-gray-200 hover:text-gray-700`}
                              >
                                Quotation
                                <span class="ml-3 rounded-full bg-indigo-100 px-2.5 py-0.5 text-xs font-medium text-gray-900 md:inline-block">
                                  {allEmployeeDatas.employeequotationdetails
                                    ?.length || "0"}
                                </span>
                              </button>
                            </nav>
                          </div>
                        </div>
                      </div>
                      <div className="mt-4">
                        {activeTabsForEmployees === "totalEmployees" && (
                          <>
                            {allEmployeeDatas?.employees?.length > 0 ? (
                              <div className="mt-6 border-t border-gray-100">
                                <div className="w-full px-4">
                                  {/* Enable scrolling while maintaining structure */}
                                  <div className="w-full overflow-x-auto sm:overflow-x-visible sm:max-h-[400px] sm:overflow-y-auto custom-scrollbar">
                                    <table className="w-full min-w-[600px] table-auto text-left">
                                      <thead className="bg-white shadow-sm">
                                        <tr>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700">
                                            Employee
                                          </th>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700 hidden sm:table-cell">
                                            Contact Info
                                          </th>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700 text-right">
                                            Actions
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {allEmployeeDatas?.employees?.map(
                                          (employee) => (
                                            <tr
                                              key={employee.id}
                                              className="border-b border-gray-200"
                                            >
                                              {/* First Column - Employee Name & Status */}
                                              <td className="relative py-4 px-4 w-1/3 sm:w-auto">
                                                <div className="flex items-start gap-x-4">
                                                  <UserIcon className="w-4 h-4 mt-1 text-gray-500" />
                                                  <div>
                                                    <div className="text-sm font-medium text-gray-900">
                                                      {employee?.name || "N/A"}
                                                    </div>
                                                    <div
                                                      className={`mt-1 text-center px-2 py-1 text-xs font-medium rounded-md ${
                                                        employee?.employee
                                                          ?.status === "1"
                                                          ? "bg-green-100 text-green-700"
                                                          : "bg-red-100 text-red-700"
                                                      }`}
                                                    >
                                                      {employee?.employee
                                                        ?.status === "1"
                                                        ? "Active"
                                                        : "Inactive"}
                                                    </div>
                                                    <div className="mt-1 text-xs text-gray-500">
                                                      Age:{" "}
                                                      {employee?.age || "N/A"}
                                                    </div>
                                                  </div>
                                                </div>
                                              </td>

                                              {/* Second Column - Contact Info */}
                                              <td className="hidden sm:table-cell py-4 px-4 w-1/3 sm:w-auto">
                                                <div className="text-sm text-gray-900">
                                                  <span className="text-xs text-gray-500">
                                                    Phone:{" "}
                                                  </span>
                                                  {employee
                                                    .employeeorganizationalinfo
                                                    ?.official_number || "N/A"}
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Email:{" "}
                                                  {employee
                                                    .employeeorganizationalinfo
                                                    ?.official_email || "N/A"}
                                                </div>
                                              </td>

                                              {/* Mobile-Friendly View (Only visible on small screens) */}
                                              <td className="sm:hidden py-4 px-4">
                                                <div className="text-sm text-gray-900">
                                                  <span className="text-xs text-gray-500">
                                                    Phone:{" "}
                                                  </span>
                                                  {employee
                                                    .employeeorganizationalinfo
                                                    ?.official_number || "N/A"}
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Email:{" "}
                                                  {employee
                                                    .employeeorganizationalinfo
                                                    ?.official_email || "N/A"}
                                                </div>
                                              </td>

                                              {/* Third Column - Actions & Date */}
                                              <td className="py-4 px-4 text-right w-1/3 sm:w-auto">
                                                <div className="flex justify-end">
                                                  <button
                                                    onClick={() =>
                                                      handleViewEmployee(
                                                        employee.id_crypt
                                                      )
                                                    }
                                                    className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
                                                  >
                                                    View Employee
                                                  </button>
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Date of Joining:{" "}
                                                  <span className="text-gray-900">
                                                    {employee
                                                      .employeeorganizationalinfo
                                                      ?.date_of_joining ||
                                                      "N/A"}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>

                                  {/* Show More / Show Less Button */}
                                  {/* {allEmployeeDatas.employees.length > 4 && (
            <div className="text-center mt-4">
              <button
                onClick={() => setShowAll(!showAll)}
                className="text-indigo-600 hover:text-indigo-500 text-sm font-medium"
              >
                {showAll ? "Show Less" : "Show More"}
              </button>
            </div>
          )} */}
                                </div>
                              </div>
                            ) : (
                              <div className="flex justify-center items-center h-44 text-gray-500 text-md font-medium">
                                No Employees Yet
                              </div>
                            )}
                          </>
                        )}

                        {activeTabsForEmployees === "leads" && (
                          <>
                            {allEmployeeDatas?.employeeleaddetails?.length >
                            0 ? (
                              <div className="mt-6 border-t border-gray-100">
                                <div className="w-full px-4">
                                  {/* Horizontal scroll for small screens, vertical scroll for large screens */}
                                  <div className="w-full overflow-x-auto sm:overflow-x-visible sm:max-h-[400px] sm:overflow-y-auto custom-scrollbar">
                                    <table className="w-full min-w-[600px] table-auto text-left">
                                      <thead className="bg-white shadow-sm">
                                        <tr>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700">
                                            Lead Value
                                          </th>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700  sm:table-cell">
                                            Lead & Employee
                                          </th>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700 text-right">
                                            Actions
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {allEmployeeDatas?.employeeleaddetails?.map(
                                          (employeeLead) => (
                                            <tr
                                              key={employeeLead.id}
                                              className="border-b border-gray-200"
                                            >
                                              {/* First Column - Lead Value & Status */}
                                              <td className="relative py-4 px-4 w-1/3 sm:w-auto">
                                                <div className="flex items-start gap-x-4">
                                                  <ChartBarIcon className="w-4 h-4 mt-1 text-gray-500" />
                                                  <div>
                                                    <div className="text-sm font-medium text-gray-900">
                                                      {employeeLead?.lead_value ||
                                                        "N/A"}
                                                    </div>
                                                    <div className="mt-1 px-2 py-1 text-xs font-medium ring-1 ring-inset rounded-md text-gray-700">
                                                      {employeeLead?.lead_status
                                                        ?.name || "N/A"}
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Mail:{" "}
                                                  {employeeLead.email_address ||
                                                    "N/A"}
                                                </div>
                                              </td>

                                              {/* Second Column - Lead & Employee */}
                                              <td className="hidden sm:table-cell py-4 px-4 w-1/3 sm:w-auto">
                                                <div className="text-sm text-gray-900">
                                                  <span className="text-xs text-gray-500">
                                                    Lead:{" "}
                                                  </span>
                                                  {employeeLead?.name || "N/A"}
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Employee:{" "}
                                                  {/* {employeeLead.task_member
                                                    ?.length
                                                    ? employeeLead.task_member
                                                        .map(
                                                          (member) =>
                                                            member.name
                                                        )
                                                        .join(", ")
                                                    : "No employee assigned"} */}
                                                  {employeeLead.lead_employee
                                                    ?.length
                                                    ? employeeLead.lead_employee
                                                        .map(
                                                          (member) =>
                                                            member.name
                                                        )
                                                        .join(", ")
                                                    : "No employee assigned"}
                                                </div>
                                              </td>

                                              {/* Mobile-Friendly View (Visible only on small screens) */}
                                              <td className="sm:hidden py-4 px-4">
                                                <div className="flex flex-col gap-1">
                                                  <div className="text-sm font-medium text-gray-900">
                                                    <span className="text-xs text-gray-500">
                                                      Lead:{" "}
                                                    </span>
                                                    {employeeLead?.name ||
                                                      "N/A"}
                                                  </div>
                                                  <div className="text-xs text-gray-500">
                                                    Employee:{" "}
                                                    {employeeLead.task_member
                                                      ?.length
                                                      ? employeeLead.task_member
                                                          .map(
                                                            (member) =>
                                                              member.name
                                                          )
                                                          .join(", ")
                                                      : "No employee assigned"}
                                                  </div>
                                                </div>
                                              </td>

                                              {/* Third Column - Actions & Date */}
                                              <td className="py-4 px-4 text-right w-1/3 sm:w-auto">
                                                <div className="flex justify-end">
                                                  <button
                                                    onClick={() =>
                                                      handleViewLead(
                                                        employeeLead.id_crypt
                                                      )
                                                    }
                                                    className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
                                                  >
                                                    View{" "}
                                                    <span className="hidden sm:inline">
                                                      Lead
                                                    </span>
                                                  </button>
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Date:{" "}
                                                  <span className="text-gray-900">
                                                    {employeeLead.created_at?.split(
                                                      "T"
                                                    )[0] || "N/A"}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="flex justify-center items-center h-44 text-gray-500 text-md font-medium">
                                No Leads Yet
                              </div>
                            )}
                          </>
                        )}

                        {activeTabsForEmployees === "tasks" && (
                          <>
                            {allEmployeeDatas?.employeetaskdetails?.length >
                            0 ? (
                              <div className="mt-6 border-t border-gray-100">
                                <div className="w-full px-4">
                                  {/* Enable horizontal scroll on small screens and vertical scroll on large screens */}
                                  <div className="w-full overflow-x-auto sm:overflow-x-visible sm:max-h-[400px] sm:overflow-y-auto custom-scrollbar">
                                    <table className="w-full min-w-[600px] table-auto text-left">
                                      <thead className="bg-white shadow-sm">
                                        <tr>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700">
                                            Task
                                          </th>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700  sm:table-cell">
                                            Lead & Employee
                                          </th>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700 text-right">
                                            Actions
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {allEmployeeDatas?.employeetaskdetails?.map(
                                          (employeeLead) => (
                                            <tr
                                              key={employeeLead.id}
                                              className="border-b border-gray-200"
                                            >
                                              {/* First Column - Task Name & Status */}
                                              <td className="relative py-4 px-4 w-1/3 sm:w-auto">
                                                <div className="flex items-start gap-x-4">
                                                  <QueueListIcon className="w-4 h-4 mt-1 text-gray-500" />
                                                  <div>
                                                    <div className="text-sm font-medium text-gray-900">
                                                      {employeeLead?.task_name ||
                                                        "N/A"}
                                                    </div>
                                                    <div className="mt-1 px-2 py-1 text-xs font-medium ring-1 ring-inset rounded-md text-gray-700">
                                                      {employeeLead
                                                        ?.task_status_name
                                                        ?.name || "N/A"}
                                                    </div>
                                                  </div>
                                                </div>
                                              </td>

                                              {/* Second Column - Lead & Employee */}
                                              <td className="hidden sm:table-cell py-4 px-4 w-1/3 sm:w-auto">
                                                <div className="text-sm text-gray-900">
                                                  <span className="text-xs text-gray-500">
                                                    Lead:{" "}
                                                  </span>
                                                  {employeeLead.lead_name
                                                    ?.name || "N/A"}
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Employee:{" "}
                                                  {employeeLead.task_member
                                                    ?.length
                                                    ? employeeLead.task_member
                                                        .map(
                                                          (member) =>
                                                            member.name
                                                        )
                                                        .join(", ")
                                                    : "No employee assigned"}
                                                </div>
                                              </td>

                                              {/* Mobile-Friendly View (Visible only on small screens) */}
                                              <td className="sm:hidden py-4 px-4">
                                                <div className="flex flex-col gap-1">
                                                  <div className="text-sm font-medium text-gray-900">
                                                    <span className="text-xs text-gray-500">
                                                      Lead:{" "}
                                                    </span>
                                                    {employeeLead.lead_name
                                                      ?.name || "N/A"}
                                                  </div>
                                                  <div className="text-xs text-gray-500">
                                                    Employee:{" "}
                                                    {employeeLead.task_member
                                                      ?.length
                                                      ? employeeLead.task_member
                                                          .map(
                                                            (member) =>
                                                              member.name
                                                          )
                                                          .join(", ")
                                                      : "No employee assigned"}
                                                  </div>
                                                </div>
                                              </td>

                                              {/* Third Column - Actions & Date */}
                                              <td className="py-4 px-4 text-right w-1/3 sm:w-auto">
                                                <div className="flex justify-end">
                                                  <button
                                                    onClick={() =>
                                                      handleViewTask(
                                                        employeeLead.id_crypt
                                                      )
                                                    }
                                                    className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
                                                  >
                                                    View{" "}
                                                    <span className="hidden sm:inline">
                                                      Task
                                                    </span>
                                                  </button>
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Date:{" "}
                                                  <span className="text-gray-900">
                                                    {employeeLead.created_at?.split(
                                                      "T"
                                                    )[0] || "N/A"}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="flex justify-center items-center h-44 text-gray-500 text-md font-medium">
                                No Tasks Not Yet Started
                              </div>
                            )}
                          </>
                        )}

                        {activeTabsForEmployees === "quotation" && (
                          <>
                            {allEmployeeDatas?.employeequotationdetails
                              ?.length > 0 ? (
                              <div className="mt-6 border-t border-gray-100">
                                <div className="w-full px-4">
                                  {/* Enable horizontal scroll on small screens and vertical scroll on large screens */}
                                  <div className="w-full overflow-x-auto sm:overflow-x-visible sm:max-h-[400px] sm:overflow-y-auto custom-scrollbar">
                                    <table className="w-full min-w-[600px] table-auto text-left">
                                      <thead className=" bg-white shadow-sm">
                                        <tr>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700">
                                            Amount
                                          </th>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700  sm:table-cell">
                                            Lead & Employee
                                          </th>
                                          <th className="py-3 px-4 text-sm font-medium text-gray-700 text-right">
                                            Actions
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {allEmployeeDatas?.employeequotationdetails?.map(
                                          (employeeLead) => (
                                            <tr
                                              key={employeeLead.id}
                                              className="border-b border-gray-200"
                                            >
                                              {/* First Column - Amount & Status */}
                                              <td className="relative py-4 px-4 w-1/3 sm:w-auto">
                                                <div className="flex items-start gap-x-4">
                                                  <ListBulletIcon className="w-4 h-4 mt-1 text-gray-500" />
                                                  <div>
                                                    <div className="text-sm font-medium text-gray-900">
                                                      {employeeLead?.total_amount ||
                                                        "N/A"}
                                                    </div>
                                                    <div className="mt-1 px-2 py-1 text-xs font-medium ring-1 ring-inset rounded-md text-gray-700">
                                                      {employeeLead
                                                        ?.quotation_status
                                                        ?.name || "N/A"}
                                                    </div>
                                                  </div>
                                                </div>
                                              </td>

                                              {/* Second Column - Lead & Employee */}
                                              <td className="hidden sm:table-cell py-4 px-4 w-1/3 sm:w-auto">
                                                <div className="text-sm text-gray-900">
                                                  <span className="text-xs text-gray-500">
                                                    Lead:{" "}
                                                  </span>
                                                  {employeeLead.lead?.name ||
                                                    "N/A"}
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Employee:{" "}
                                                  {employeeLead.employee
                                                    ?.name ||
                                                    "No employee assigned"}
                                                </div>
                                              </td>

                                              {/* Mobile-Friendly View (Visible only on small screens) */}
                                              <td className="sm:hidden py-4 px-4">
                                                <div className="flex flex-col gap-1">
                                                  <div className="text-sm font-medium text-gray-900">
                                                    <span className="text-xs text-gray-500">
                                                      Lead:{" "}
                                                    </span>
                                                    {employeeLead.lead?.name ||
                                                      "N/A"}
                                                  </div>
                                                  <div className="text-xs text-gray-500">
                                                    Employee:{" "}
                                                    {employeeLead.employee
                                                      ?.name ||
                                                      "No employee assigned"}
                                                  </div>
                                                </div>
                                              </td>

                                              {/* Third Column - Actions & Date */}
                                              <td className="py-4 px-4 text-right w-1/3 sm:w-auto">
                                                <div className="flex justify-end">
                                                  <button
                                                    onClick={() =>
                                                      handleViewQuotation(
                                                        employeeLead.id_crypt
                                                      )
                                                    }
                                                    className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
                                                  >
                                                    View{" "}
                                                    <span className="hidden sm:inline">
                                                      Quotation
                                                    </span>
                                                  </button>
                                                </div>
                                                <div className="mt-1 text-xs text-gray-500">
                                                  Date:{" "}
                                                  <span className="text-gray-900">
                                                    {employeeLead?.quotation_validity_date ||
                                                      "N/A"}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="flex justify-center items-center h-44 text-gray-500 text-md font-medium">
                                No Quotations Yet
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* end */}
        </main>
      )}

      {showNotification && (
        <Notification
          message={notificationMessage}
          onClose={() => setShowNotification(false)}
        />
      )}
    </div>
  );
}

export default LeadDashboardPage;
